<fui-rows>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="model.data.outletStocks" [editable]="true" [entityPath]="'outletStocks'"
                           [removable]="true">
                <wbo-edit-link-column field="outlet.name" componentPath="outlet"
                                      [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                <wbo-numeric-column field="stockSize.measureAmt" [editable]="true"></wbo-numeric-column>
                <wbo-measure-single-select-column field="stockSize.measure"
                                                  [inventoryMeasureIdentifier]="model.data.standardStockSize.measure.measureId"
                                                  [convertToRequired]="true"
                                                  [editable]="true"></wbo-measure-single-select-column>
                <wbo-numeric-column field="minLevel" [editable]="true"></wbo-numeric-column>
                <wbo-numeric-column field="maxLevel" [editable]="true"></wbo-numeric-column>
                <wbo-checkbox-column field="purchaseOrder" [editable]="true"></wbo-checkbox-column>
                <wbo-checkbox-column field="receiveOrder" [editable]="true"></wbo-checkbox-column>
                <wbo-checkbox-column field="stockTransfer" [editable]="true"></wbo-checkbox-column>
                <wbo-edit-grid-add-row [identifierField]="'outletId'" componentPath="outlet" #addRow
                                       [customAddQuickSelect]="true">
                    <wbo-edit-grid-add-row-quick-add (onSelect)="addRow.addRow($event, true)">
                        <wbo-outlet-single-select-edit-control></wbo-outlet-single-select-edit-control>
                    </wbo-edit-grid-add-row-quick-add>
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-search
                            [searchComponent]="OutletSearchPageComponent"></wbo-edit-grid-add-row-search>
                        <wbo-edit-grid-add-row-new-entity
                            [editComponent]="OutletEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
</fui-rows>
